import React from 'react'
import QRgenerator from './QRgenerator'

export default function ScanBarcode() {
  return (
    <div>
    <div className='w-full bg-teal-100'>
    <div className='m-auto justify-center text-center'>

    <QRgenerator/>
    </div>
    </div>
    
    </div>
  )
}
